/* Rquiere de mixin.js */

var manifesto = {
	data () {
		return {
			fromDateManifestos: '2020-07-15',
			toDateManifestos: '2020-07-18',
            listManifestos: [],
			manifestoIDSelected: 0,
			methodsManifesto: {
				create: 'manifesto/register',
				delete: '/delete',
				get: 'manifestos',
				show: 'manifesto/',
				manifestoTrackingsManifestoCreate: '/trackingsManifesto/register',
			},
			objectManifesto: {
				id: 0,
				transport_id: 0,
				transport: '',
				name: '',
				description: '',
				status_id: 0,
				status: '',
				barcode: '',
				manifesto_shipping: [],
				opened: false,
				shippings: [],
				created_at: '',
				updated_at: '',
            },
			paginationManifestos: [],
			qRowsManifesto: 25,
            searchingManifestos: false,
			searchingManifesto: false,
			localStorageManifesto: {
				coordinator: '',
				driver: '',
				responsable: '',
			},
			trackingsManifestoShipping: [
				{ trackings_manifesto_id: '6', trackings_shipping_id: '3'}
			]
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        addListManifestos(newManifesto) {
            this.listManifestos.unshift(newManifesto)
            this.clearObjectManifesto()
        },
		addManifestoTrackingsManifesto(id, trackingsManifestoId){
			let param = 
				{'trackingsManifestoId': trackingsManifestoId }

			this.$emit('showLockScreen', 'Guardando agregando seguimiento . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsManifesto.show + id + this.methodsManifesto.manifestoTrackingsManifestoCreate, 'POST', 'addManifestoTrackingsManifestoResult', param)
		},
		addManifestoTrackingsManifestoResult(response) {
			this.updateStatusManifesto(response.data.data)
			this.socketEmit(['NEW_MANIFESTO_TRACKINGS_MANIFESTO'], response.data.data)
		},
        deleteItemListManifestos(id) {
			let index = this.listManifestos.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if(index > -1)
				return this.listManifestos.splice(index, 1)
			return false
		},
		deleteListManifestosManifestoShipping(id, shippingId) {
			let index = this.objectManifesto.shippings.map((el) => parseInt(el.id)).indexOf(parseInt(shippingId))
			this.objectManifesto.shippings.splice(index, 1)
			
			index = this.listManifestos.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if(index > -1) {
				index = this.listManifestos[index].shippings.map((el) => parseInt(el.id)).indexOf(parseInt(shippingId))
				if(index > -1)
					return this.listManifestos[index].shippings.splice(index, 1)
			}
			return false
		},
		deleteManifesto(id) {
			this.$emit('showLockScreen', 'Borrando Manifiesto . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsManifesto.show + id + this.methodsManifesto.delete, 'DELETE', 'deleteManifestoResult')
		},
		deleteManifestoResult(response) {
			if(response.data.success) {
				this.socketEmit(['DELETE_MANIFESTO'], response.data.data)
				this.deleteManifestoResultLocal(this.deleteItemListManifestos(response.data.data))
			}
		},
		deleteManifestoResultLocal(item) {
			console.log('deleteManifestoResultLocal no desarrollado', item)
		},
		deleteManifestoShipping(id, shippingId) {
			this.$emit('showLockScreen', 'Borrando envio Nº ' + shippingId + ' del manifiesto ' + id + ' . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsManifesto.show + id + '/shipping/' + shippingId + this.methodsManifesto.delete, 'DELETE', 'deleteManifestoShippingResult')
		},
		deleteManifestoShippingResult(response) {
			this.deleteListManifestosManifestoShipping(response.data.manifesto_id, response.data.shipping_id)
			this.addShippingTrackingsShipping(response.data.shipping_id, 7, 'Removido del manifiesto ' + response.data.manifesto_id)
			this.deleteManifestoShippingResultLocal(response)
		},
		deleteManifestoShippingResultLocal(response) {
			console.log('deleteManifestoShippingResultLocal no desarrollado', response)
		},
        changeQRowsManifesto() {
            localStorage.setItem('qRowsManifesto', this.qRowsManifesto)
            this.getAllShippings()
        },
        clearObjectManifesto() {
            this.objectManifesto.id = 0
            this.objectManifesto.transport_id = 0
            this.objectManifesto.transport = ''
            this.objectManifesto.color = ''
            this.objectManifesto.name = ''
            this.objectManifesto.description = ''
            this.objectManifesto.status_id = 0
            this.objectManifesto.status = ''
            this.objectManifesto.barcode = ''
            this.objectManifesto.manifesto_shipping = []
			this.objectManifesto.opened = false
            this.objectManifesto.shippings = []
            this.objectManifesto.created_at = ''
            this.objectManifesto.updated_at = ''
        },
		getAllManifestos(page = 1) {
			this.searchingManifestos = true
			this.listManifestos = []
			this.paginationManifestos = []
			let parameters = '?page=' + page + '&qRow=' + this.qRowsManifesto + '&fromDate=' + this.fromDateManifestos + '&toDate=' + this.toDateManifestos
			this.$emit('showLockScreen', 'Obteniendo manifiestos . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsManifesto.get + parameters, 'GET', 'getAllManifestosResult')
		},
		getAllManifestosByStatusId(statusId) {
			let parameters = '?statusId=' + statusId
			let url = this.getApiBackend + this.methodsManifesto.get + 'ByStatus' + parameters
			this.axiosActionIS(url, 'GET', 'getAllManifestosResult')
		},
        getAllManifestosResult(response) {
			this.searchingManifestos = false
			if(response.data.success == true) {
				this.listManifestos = response.data.data
				this.paginationManifestos = response.data.paginate  	
			}
			this.getAllManifestosResultLocal(response)
        },
		getAllManifestosResultLocal(response) {
			console.log('getAllManifestosResultLocal no desarrollado', response)
		},
		getColorManifestoTransport(id, concepto = 'TRANS') {
			let index = this.listManifestos.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			if(index > -1){
				return this.getColorTransport(this.listManifestos[index].transport_id)
			}
			return 'Sin Definir'
		},
		getLocalStorageManifesto() {
			let localStorageManifesto = localStorage.getItem('localStorageManifesto')
			if(localStorageManifesto != null) {
				this.localStorageManifesto = JSON.parse(localStorageManifesto)
			}
		},
		saveManifesto() {
			let method = (this.objectManifesto.id == 0) ? 'POST' : 'PUT'
			this.$emit('showLockScreen', 'Guardando datos . . .')
			if(method == 'POST') {
				this.axiosActionIS(this.getApiBackend + this.methodsManifesto.create, method, 'saveManifestoResult', this.objectManifesto)
			} else if(method == 'PUT') {
				console.log(this.getApiBackend + this.methodsManifesto.update, 'PUT')
				//this.axiosActionIS(this.getApiBackend + this.methods.shippingRequestUpdate, method, 'resultSaveShippingRequestPUT', this.objectShippingRequest)
			}
		},
        saveManifestoResult(response) {
			if(response.data.success == true) {
				if(response.data.message == 'NEW') {
					this.addListManifestos(response.data.data)
				}
			}
			/*if(response.data.success) {
				if(responseLocal == 'saveManifestoPOSTResult') {
					this.addListManifestos(response.data.data)
					this.socketEmit(['NEW_MANIFESTO'], response.data.data)
				} else if(responseLocal == 'saveManifestoPOSTResult') {
					this.updateItemListManifesto(response.data.data)
					this.socketEmit(['UPDATE_MANIFESTO'], response.data.data)
				}
				this.clearObjectManifesto()
				console.log('Manifiesto guardado con exito')
			} else {
                console.log(response)
			}*/
			this.saveManifestoResultLocal(response)
        },
		saveManifestoResultLocal(response) {
			console.log('saveManifestoResult no desarrollado', response)
		},
		setListeningManifesto() {
			this.sockets.subscribe('DELETE_MANIFESTO', (data) => { this.deleteItemListManifestos(data.body) })
			this.sockets.subscribe('NEW_MANIFESTO', (data) => { this.addListManifestos(data.body) })
			this.sockets.subscribe('NEW_MANIFESTO_TRACKINGS_MANIFESTO', (data) => { this.updateStatusManifesto(data.body) })
			this.sockets.subscribe('UPDATE_MANIFESTO', (data) => { this.updateItemListManifestos(data.body) })
		},
		setLocalStorageManifesto() {
			localStorage.setItem('localStorageManifesto', JSON.stringify(this.localStorageManifesto))
		},
        setObjectManifesto(item) {
			for (const property in item) {
				this.objectManifesto[property] = item[property]
			}
        },
		showManifesto(id, action = 'view') {
			this.searchingManifesto = true
			let param = '?action='+action
			let url = this.getApiBackend + this.methodsManifesto.show + id + param
			this.axiosActionIS(url, 'GET', 'showManifestoResult', null)
		},
		showManifestoResult(response) {
			this.searchingManifesto = false
			if(response.data.success) {
				this.setObjectManifesto(response.data.data)
				this.showManifestoResultLocal(response)
			} else {
				let msg = response.data.message
				this.$snotify.error(msg, 'Error')
				console.log(msg, response)
			}
		},
		showManifestoResultLocal(response){
			console.log('showManifestoResultLocal no desarrollado', response)
		},
		updateStatusManifesto(manifestoTrackingsManifesto) {
			if(Object.entries(manifestoTrackingsManifesto.statu).length > 0) {
				let index = this.listManifestos.map((el) => parseInt(el.id)).indexOf(parseInt(manifestoTrackingsManifesto.manifesto_id))
				if(index > -1) {
					this.listManifestos[index].status_id = manifestoTrackingsManifesto.statu.id
					this.listManifestos[index].status = manifestoTrackingsManifesto.statu.name
					this.listManifestos[index].color = manifestoTrackingsManifesto.statu.color
					this.listManifestos[index].opened = (manifestoTrackingsManifesto.statu.id == 26) ? true : false
					this.updateStatusManifestoLocal(manifestoTrackingsManifesto)
				}
			}
		},
		updateStatusManifestoLocal(manifestoTrackingsManifesto) {
			console.log('manifestoTrackingsManifesto no desarrolado', manifestoTrackingsManifesto)
		},
		urlShowManifesto(id) {
			let url = this.getUrl + 'manifesto/' + id
			return url
		}
	},
};

export default manifesto;